import React, { useState, useCallback, useRef, useMemo, useEffect, createElement, useContext } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var IDrawMode;

(function (IDrawMode) {
  IDrawMode[IDrawMode["DRAW"] = 0] = "DRAW";
  IDrawMode[IDrawMode["SELECT"] = 1] = "SELECT";
})(IDrawMode || (IDrawMode = {}));

var Color;

(function (Color) {
  Color["WHITE"] = "#fff";
  Color["RED"] = "#f55a6c";
  Color["YELLOW"] = "#f7c825";
  Color["GREEN"] = "#63d320";
  Color["BLUENESS"] = "#4fe2c2";
  Color["BLUE"] = "#59b9fe";
  Color["PURPLE"] = "#bd0fe0";
  Color["BLACK"] = "#000";
})(Color || (Color = {}));

var PaintingStateContext = /*#__PURE__*/React.createContext(null);
function PaintingStateProvider(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      drawing = _useState2[0],
      setDrawing = _useState2[1];

  var _useState3 = useState(IDrawMode.DRAW),
      _useState4 = _slicedToArray(_useState3, 2),
      drawMode = _useState4[0],
      setDrawMode = _useState4[1];

  var _useState5 = useState({
    type: 'line',
    drawColor: Color.BLACK,
    drawWidth: 4
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      workingDrawTool = _useState6[0],
      setWorkingDrawTool = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      shapes = _useState8[0],
      setShapes = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      redoShapes = _useState10[0],
      setRedoShapes = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      selectedShape = _useState12[0],
      setSelectedShape = _useState12[1];

  var addShape = useCallback(function (shape) {
    setShapes(function (sp) {
      return [].concat(_toConsumableArray(sp), [shape]);
    });
  }, [setShapes]);
  var updateShape = useCallback(function (id, shape) {
    if (!shape) {
      return;
    }

    setShapes(function (sp) {
      return sp.map(function (s) {
        if (s.id !== id) {
          return s;
        }

        return shape;
      });
    });
    setSelectedShape(function (sp) {
      return (sp === null || sp === void 0 ? void 0 : sp.id) === id ? shape : sp;
    });
  }, [setShapes, setSelectedShape]);
  var removeShape = useCallback(function (shapeId) {
    setShapes(function (sp) {
      return sp.filter(function (s) {
        return s.id !== shapeId;
      });
    });
    setSelectedShape(null);
  }, [setShapes, setSelectedShape]);
  var cleanRedoShapes = useCallback(function () {
    setRedoShapes([]);
  }, [setRedoShapes]);
  var undo = useCallback(function () {
    var lastOne = shapes[shapes.length - 1];
    setShapes(shapes.slice(0, -1));
    setRedoShapes(function (sp) {
      return [].concat(_toConsumableArray(sp), [lastOne]);
    });
  }, [shapes, setShapes, setRedoShapes]);
  var redo = useCallback(function () {
    var lastOne = redoShapes[redoShapes.length - 1];
    setRedoShapes(redoShapes.slice(0, -1));
    setShapes(function (sp) {
      return [].concat(_toConsumableArray(sp), [lastOne]);
    });
  }, [redoShapes, setShapes, setRedoShapes]);
  var cleanBoard = useCallback(function () {
    setShapes([]);
    setRedoShapes([]);
  }, [setShapes, setRedoShapes]);
  return /*#__PURE__*/React.createElement(PaintingStateContext.Provider, Object.assign({
    value: {
      drawing: drawing,
      setDrawing: setDrawing,
      drawMode: drawMode,
      setDrawMode: setDrawMode,
      workingDrawTool: workingDrawTool,
      setWorkingDrawTool: setWorkingDrawTool,
      shapes: shapes,
      addShape: addShape,
      updateShape: updateShape,
      removeShape: removeShape,
      redoShapes: redoShapes,
      cleanRedoShapes: cleanRedoShapes,
      selectedShape: selectedShape,
      setSelectedShape: setSelectedShape,
      undo: undo,
      redo: redo,
      cleanBoard: cleanBoard
    }
  }, props));
}

function id() {
  var base = 'abcdefghijklmnopqrstuvwxyz';
  var i0 = Math.floor(Math.random() * 26);
  var i1 = Math.floor(Math.random() * 26);
  var i2 = Math.floor(Math.random() * 26);
  return "".concat(base[i0]).concat(base[i1]).concat(base[i2], "-").concat(new Date().getTime());
}
function capitalize(str) {
  return str.toLowerCase().replace(/^[a-z]/, function (word) {
    return word.toUpperCase();
  });
}
function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}
function isNumeric(obj) {
  var NUM_REG = /^-?\d+(\.\d+)?$/;

  if (Object.prototype.toString.call(obj) === '[object Number]') {
    return true;
  }

  if (isString(obj)) {
    return NUM_REG.test(obj);
  }

  return false;
}

function createCancelablePromise(promise) {
  var isCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (value) {
      if (isCanceled) {
        reject({
          isCanceled: isCanceled,
          value: value
        });
        return;
      }

      resolve(value);
    }, function (error) {
      reject({
        isCanceled: isCanceled,
        error: error
      });
    });
  });
  var cancelablePromise = wrappedPromise;

  cancelablePromise.cancel = function () {
    isCanceled = true;
  };

  return cancelablePromise;
}
function delay(timeout) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
}

function mimes() {
  /*
   * Only WOFF and EOT mime types for fonts are 'real'
   * see http://www.iana.org/assignments/media-types/media-types.xhtml
   */
  var WOFF = 'application/font-woff';
  var JPEG = 'image/jpeg';
  return {
    woff: WOFF,
    woff2: WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: JPEG,
    jpeg: JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml'
  };
}

function px(node, styleProperty) {
  var value = window.getComputedStyle(node).getPropertyValue(styleProperty);
  return parseFloat(value.replace('px', ''));
}

function escape(str) {
  return str.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1');
}
function parseExtension(url) {
  var match = /\.([^./]*?)$/g.exec(url);

  if (match) {
    return match[1];
  }

  return '';
}
function mimeType(url) {
  var extension = parseExtension(url).toLowerCase();
  var mimeMap = mimes();

  if (Object.keys(mimeMap).includes(extension)) {
    return mimeMap[extension];
  }

  return '';
}
function dataAsUrl(content, type) {
  return 'data:' + type + ';base64,' + content;
}
function isDataUrl(url) {
  return url.search(/^(data:)/) !== -1;
}
function resolveUrl(url, baseUrl) {
  var doc = document.implementation.createHTMLDocument();
  var base = doc.createElement('base');
  doc.head.appendChild(base);
  var a = doc.createElement('a');
  doc.body.appendChild(a);
  base.href = baseUrl;
  a.href = url;
  return a.href;
}
function getAndEncode(url) {
  var TIMEOUT = 30000;
  return new Promise(function (resolve) {
    var request = new XMLHttpRequest();
    request.onreadystatechange = done;
    request.ontimeout = timeout;
    request.responseType = 'blob';
    request.timeout = TIMEOUT;
    request.open('GET', url, true);
    request.send();

    function done() {
      if (request.readyState !== 4) return;

      if (request.status !== 200) {
        fail('cannot fetch resource: ' + url + ', status: ' + request.status);
        return;
      }

      var encoder = new FileReader();

      encoder.onloadend = function () {
        var content = encoder.result.split(/,/)[1];
        resolve(content);
      };

      encoder.readAsDataURL(request.response);
    }

    function timeout() {
      fail('timeout of ' + TIMEOUT + 'ms occured while fetching resource: ' + url);
    }

    function fail(message) {
      console.error(message);
      resolve('');
    }
  });
}
function asArray(arrayLike) {
  var array = [];
  var length = arrayLike.length;

  for (var i = 0; i < length; i++) {
    array.push(arrayLike[i]);
  }

  return array;
}
function escapeXhtml(str) {
  return str.replace(/#/g, '%23').replace(/\n/g, '%0A');
}
function makeImage(uri) {
  return new Promise(function (resolve, reject) {
    var image = new Image();

    image.onload = function () {
      resolve(image);
    };

    image.onerror = reject;
    image.src = uri;
  });
}
function width(node) {
  var leftBorder = px(node, 'border-left-width');
  var rightBorder = px(node, 'border-right-width');
  return node.scrollWidth + leftBorder + rightBorder;
}
function height(node) {
  var topBorder = px(node, 'border-top-width');
  var bottomBorder = px(node, 'border-bottom-width');
  return node.scrollHeight + topBorder + bottomBorder;
}
function delay$1(ms) {
  return function (arg) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(arg);
      }, ms);
    });
  };
}

var URL_REGEX = /url\(['"]?([^'"]+?)['"]?\)/g;
function shouldProcess(string) {
  return string.search(URL_REGEX) !== -1;
}
function readUrls(string) {
  var result = [];
  var match;

  while ((match = URL_REGEX.exec(string)) !== null) {
    result.push(match[1]);
  }

  return result.filter(function (url) {
    return !isDataUrl(url);
  });
}
function inline(string, url, baseUrl, get) {
  return Promise.resolve(url).then(function (url) {
    return baseUrl ? resolveUrl(url, baseUrl) : url;
  }).then(get || getAndEncode).then(function (data) {
    return dataAsUrl(data, mimeType(url));
  }).then(function (dataUrl) {
    return string.replace(urlAsRegex(url), '$1' + dataUrl + '$3');
  });

  function urlAsRegex(url) {
    return new RegExp('(url\\([\'"]?)(' + escape(url) + ')([\'"]?\\))', 'g');
  }
}
function inlineAll(string, baseUrl, get) {
  if (nothingToInline()) return Promise.resolve(string);
  return Promise.resolve(string).then(readUrls).then(function (urls) {
    var done = Promise.resolve(string);
    urls.forEach(function (url) {
      done = done.then(function (string) {
        return inline(string, url, baseUrl, get);
      });
    });
    return done;
  });

  function nothingToInline() {
    return !shouldProcess(string);
  }
}

//   inlineAll: inlineAll,
//   impl: {
//     newImage: newImage,
//   },
// }

function newImage(element) {
  return {
    inline: function inline(get) {
      if (isDataUrl(element.src)) {
        return Promise.resolve();
      }

      return Promise.resolve(element.src).then(get || getAndEncode).then(function (data) {
        return dataAsUrl(data, mimeType(element.src));
      }).then(function (dataUrl) {
        return new Promise(function (resolve, reject) {
          element.onload = resolve;
          element.onerror = reject;
          element.src = dataUrl;
        });
      });
    }
  };
}
function inlineAll$1(node) {
  if (!(node instanceof Element)) {
    return Promise.resolve(node);
  }

  function inlineBackground(node) {
    var background = node.style.getPropertyValue('background');

    if (!background) {
      return Promise.resolve(node);
    }

    return inlineAll(background, undefined).then(function (inlined) {
      node.style.setProperty('background', inlined, node.style.getPropertyPriority('background'));
    }).then(function () {
      return node;
    });
  }

  return inlineBackground(node).then(function () {
    if (node instanceof HTMLImageElement) {
      return newImage(node).inline();
    }

    return Promise.all(asArray(node.childNodes).map(function (child) {
      return inlineAll$1(child);
    }));
  });
}

function resolveAll() {
  return readAll().then(function (webFonts) {
    return Promise.all(webFonts.map(function (webFont) {
      return webFont.resolve();
    }));
  }).then(function (cssStrings) {
    return cssStrings.join('\n');
  });
}
function readAll() {
  return Promise.resolve(asArray(document.styleSheets)).then(getCssRules).then(selectWebFontRules).then(function (rules) {
    return rules.map(newWebFont);
  });

  function selectWebFontRules(cssRules) {
    return cssRules.filter(function (rule) {
      return rule.type === CSSRule.FONT_FACE_RULE;
    }).filter(function (rule) {
      return shouldProcess(rule.style.getPropertyValue('src'));
    });
  }

  function getCssRules(styleSheets) {
    var cssRules = [];
    styleSheets.forEach(function (sheet) {
      try {
        asArray(sheet.cssRules || []).forEach(function (rule) {
          cssRules.push(rule);
        });
      } catch (e) {
        console.log('Error while reading CSS rules from ' + sheet.href, e.toString());
      }
    });
    return cssRules;
  }

  function newWebFont(webFontRule) {
    return {
      resolve: function resolve() {
        var baseUrl = (webFontRule.parentStyleSheet || {}).href;
        return inlineAll(webFontRule.cssText, baseUrl);
      },
      src: function src() {
        return webFontRule.style.getPropertyValue('src');
      }
    };
  }
}

function toSvg(node) {
  return Promise.resolve(node).then(function (node) {
    return cloneNode(node);
  }).then(embedFonts).then(inlineImages).then(function (clone) {
    return makeSvgDataUri(clone, width(node), height(node));
  });
}

function downloadAsPng(node, fileName) {
  return draw(node).then(function (canvas) {
    var link = document.createElement('a');
    link.download = fileName;
    link.href = canvas.toDataURL();
    link.click();
  });
}

function draw(domNode) {
  return toSvg(domNode).then(makeImage).then(delay$1(100)).then(function (image) {
    var canvas = newCanvas(domNode);
    canvas.getContext('2d').drawImage(image, 0, 0);
    return canvas;
  });

  function newCanvas(domNode) {
    var canvas = document.createElement('canvas');
    canvas.width = width(domNode);
    canvas.height = height(domNode);
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    return canvas;
  }
}

function cloneNode(node, root) {
  return Promise.resolve(node).then(makeNodeCopy).then(function (clone) {
    return cloneChildren(node, clone);
  }).then(function (clone) {
    return processClone(node, clone);
  });

  function makeNodeCopy(node) {
    if (node instanceof HTMLCanvasElement) {
      return makeImage(node.toDataURL());
    }

    return node.cloneNode(false);
  }

  function cloneChildren(original, clone) {
    var children = original.childNodes;

    if (children.length === 0) {
      return Promise.resolve(clone);
    }

    return cloneChildrenInOrder(clone, asArray(children)).then(function () {
      return clone;
    });

    function cloneChildrenInOrder(parent, children) {
      var done = Promise.resolve();
      children.forEach(function (child) {
        done = done.then(function () {
          return cloneNode(child);
        }).then(function (childClone) {
          if (childClone) {
            parent.appendChild(childClone);
          }
        });
      });
      return done;
    }
  }

  function processClone(original, clone) {
    if (!(clone instanceof Element)) {
      return clone;
    }

    return Promise.resolve().then(cloneStyle).then(clonePseudoElements).then(copyUserInput).then(fixSvg).then(function () {
      return clone;
    });

    function cloneStyle() {
      copyStyle(window.getComputedStyle(original), clone.style);

      function copyStyle(source, target) {
        if (source.cssText) {
          target.cssText = source.cssText;
        } else {
          copyProperties(source, target);
        }

        function copyProperties(source, target) {
          asArray(source).forEach(function (name) {
            target.setProperty(name, source.getPropertyValue(name), source.getPropertyPriority(name));
          });
        }
      }
    }

    function clonePseudoElements() {
      [':before', ':after'].forEach(function (element) {
        clonePseudoElement(element);
      });

      function clonePseudoElement(element) {
        var style = window.getComputedStyle(original, element);
        var content = style.getPropertyValue('content');

        if (content === '' || content === 'none') {
          return;
        }

        var className = id();
        clone.className = clone.className + ' ' + className;
        var styleElement = document.createElement('style');
        styleElement.appendChild(formatPseudoElementStyle(className, element, style));
        clone.appendChild(styleElement);

        function formatPseudoElementStyle(className, element, style) {
          var selector = '.' + className + ':' + element;
          var cssText = style.cssText ? formatCssText(style) : formatCssProperties(style);
          return document.createTextNode(selector + '{' + cssText + '}');

          function formatCssText(style) {
            var content = style.getPropertyValue('content');
            return style.cssText + ' content: ' + content + ';';
          }

          function formatCssProperties(style) {
            return asArray(style).map(formatProperty).join('; ') + ';';

            function formatProperty(name) {
              return name + ': ' + style.getPropertyValue(name) + (style.getPropertyPriority(name) ? ' !important' : '');
            }
          }
        }
      }
    }

    function copyUserInput() {
      if (original instanceof HTMLTextAreaElement) {
        clone.innerHTML = original.value;
      }

      if (original instanceof HTMLInputElement) {
        clone.setAttribute('value', original.value);
      }
    }

    function fixSvg() {
      if (!(clone instanceof SVGElement)) return;
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      if (!(clone instanceof SVGRectElement)) return;
      ['width', 'height'].forEach(function (attribute) {
        var value = clone.getAttribute(attribute);
        if (!value) return;
        clone.style.setProperty(attribute, value);
      });
    }
  }
}

function embedFonts(node) {
  return resolveAll().then(function (cssText) {
    var styleNode = document.createElement('style');
    node.appendChild(styleNode);
    styleNode.appendChild(document.createTextNode(cssText));
    return node;
  });
}

function inlineImages(node) {
  return inlineAll$1(node).then(function () {
    return node;
  });
}

function makeSvgDataUri(node, width, height) {
  return Promise.resolve(node).then(function (node) {
    node.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    return new XMLSerializer().serializeToString(node);
  }).then(escapeXhtml).then(function (xhtml) {
    return '<foreignObject x="0" y="0" width="100%" height="100%">' + xhtml + '</foreignObject>';
  }).then(function (foreignObject) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '">' + foreignObject + '</svg>';
  }).then(function (svg) {
    return 'data:image/svg+xml;charset=utf-8,' + svg;
  });
}

function useClickHooks() {
  var stateRef = useRef([]);
  var addToPendingPromises = useCallback(function (promise) {
    stateRef.current.push(promise);
  }, [stateRef]);
  var removeFromPendingPromises = useCallback(function (promise) {
    stateRef.current = stateRef.current.filter(function (p) {
      return p !== promise;
    });
  }, [stateRef]);
  var clearPendingPromises = useCallback(function () {
    stateRef.current.forEach(function (p) {
      p.cancel();
    });
    stateRef.current = [];
  }, [stateRef]);
  var createDoubleClickHandler = useCallback(function (onDoubleClick) {
    return function (e) {
      clearPendingPromises();
      onDoubleClick(e.nativeEvent);
    };
  }, [clearPendingPromises]);
  var createClickHandler = useCallback(function (onClick) {
    return function (e) {
      // create the cancelable promise and add it to
      // the pending promises queue
      var waitForClick = createCancelablePromise(delay(200));
      addToPendingPromises(waitForClick);
      var event = e.nativeEvent;
      waitForClick.then(function () {
        // if the promise wasn't cancelled, we execute
        // the callback and remove it from the queue
        // removeFromPendingPromises(waitForClick)
        onClick(event);
      }).catch(function (errorInfo) {
        // rethrow the error if the promise wasn't
        // rejected because of a cancelation
        removeFromPendingPromises(waitForClick);

        if (!errorInfo.isCanceled) {
          throw errorInfo.error;
        }
      });
    };
  }, [addToPendingPromises, removeFromPendingPromises]);
  return {
    createClickHandler: createClickHandler,
    createDoubleClickHandler: createDoubleClickHandler
  };
}

function classnames() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (result, key) {
    if (key === undefined || key === null) {
      return result;
    }

    if (isString(key)) {
      return "".concat(result, " ").concat(key);
    }

    var keys = Object.keys(key);
    var computed = keys.reduce(function (prev, c) {
      if (key[c]) {
        return "".concat(prev, " ").concat(c);
      }

      return prev;
    }, '');
    return "".concat(result, " ").concat(computed);
  }, '');
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".index_path__95esX {\n  fill: none;\n}\n.index_lineHover__2_6vR:hover {\n  stroke: #007fe1;\n}\n";
var styles = {"path":"index_path__95esX","lineHover":"index_lineHover__2_6vR"};
styleInject(css_248z);

function Line(_ref) {
  var drawing = _ref.drawing,
      line = _ref.line,
      onClick = _ref.onClick;
  var pathData = 'M ' + line.points.map(function (p) {
    return "".concat(p.x, " ").concat(p.y);
  }).join(' L ');
  return /*#__PURE__*/React.createElement("path", {
    onClick: onClick,
    id: line.id,
    className: classnames(styles.path, _defineProperty({}, styles.lineHover, !drawing)),
    d: pathData,
    stroke: line.lineColor,
    strokeWidth: line.lineWidth
  });
}
function createLine(point, workingDrawTool) {
  return {
    id: id(),
    lineColor: workingDrawTool.drawColor,
    lineWidth: workingDrawTool.drawWidth,
    type: 'line',
    points: [point]
  };
}
function drawLine(line, point) {
  return _objectSpread2(_objectSpread2({}, line), {}, {
    points: [].concat(_toConsumableArray(line.points), [point])
  });
}

var css_248z$1 = ".index_path__EVpTj {\n  fill: none;\n}\n.index_lineHover__2McNk:hover {\n  stroke: #007fe1;\n}\n";
var styles$1 = {"path":"index_path__EVpTj","lineHover":"index_lineHover__2McNk"};
styleInject(css_248z$1);

function ArrowLineMarker(_ref) {
  var arrowLine = _ref.arrowLine;
  return /*#__PURE__*/React.createElement("marker", {
    id: "marker-".concat(arrowLine.id),
    markerWidth: 10,
    markerHeight: 10,
    markerUnits: "strokeWidth",
    refX: "3",
    refY: "4",
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L2,6 L4,4",
    style: {
      fill: arrowLine.lineColor
    }
  }));
}
function ArrowLine(_ref2) {
  var drawing = _ref2.drawing,
      arrowLine = _ref2.arrowLine,
      onClick = _ref2.onClick;
  var pathData = 'M ' + arrowLine.points.map(function (p) {
    return "".concat(p.x, " ").concat(p.y);
  }).join(' L ');
  return /*#__PURE__*/React.createElement("path", {
    onClick: onClick,
    id: arrowLine.id,
    className: classnames(styles$1.path, _defineProperty({}, styles$1.lineHover, !drawing)),
    d: pathData,
    stroke: arrowLine.lineColor,
    strokeWidth: arrowLine.lineWidth,
    markerEnd: "url(#marker-".concat(arrowLine.id, ")")
  });
}
function createArrowLine(point, workingDrawTool) {
  return {
    id: id(),
    lineColor: workingDrawTool.drawColor,
    lineWidth: workingDrawTool.drawWidth,
    type: 'arrow-line',
    points: [point]
  };
}
function drawArrowLine(arrowLine, point) {
  return _objectSpread2(_objectSpread2({}, arrowLine), {}, {
    points: [].concat(_toConsumableArray(arrowLine.points), [point])
  });
}

var css_248z$2 = ".index_rectHover__DIYWr:hover {\n  stroke: #007fe1 !important;\n}\n";
var styles$2 = {"rectHover":"index_rectHover__DIYWr"};
styleInject(css_248z$2);

function Rect(_ref) {
  var drawing = _ref.drawing,
      rect = _ref.rect,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("rect", {
    onClick: onClick,
    id: rect.id,
    x: rect.x,
    y: rect.y,
    width: rect.width,
    height: rect.height,
    style: {
      fill: 'none',
      stroke: rect.lineColor,
      strokeWidth: rect.lineWidth
    },
    className: classnames(_defineProperty({}, styles$2.rectHover, !drawing))
  });
}
function createRect(point, workingDrawTool) {
  return {
    id: id(),
    lineColor: workingDrawTool.drawColor,
    lineWidth: workingDrawTool.drawWidth,
    type: 'rect',
    x: point.x,
    y: point.y,
    width: 1,
    height: 1
  };
}
function drawRect(rect, point) {
  var width = point.x - rect.x;
  var height = point.y - rect.y;

  if (width < 1 || height < 1) {
    return null;
  }

  return _objectSpread2(_objectSpread2({}, rect), {}, {
    width: width,
    height: height
  });
}

var css_248z$3 = ".index_ellipseHover__2doa6:hover {\n  stroke: #007fe1 !important;\n}\n";
var styles$3 = {"ellipseHover":"index_ellipseHover__2doa6"};
styleInject(css_248z$3);

function Ellipse(_ref) {
  var drawing = _ref.drawing,
      ellipse = _ref.ellipse,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("ellipse", {
    onClick: onClick,
    id: ellipse.id,
    cx: ellipse.cx,
    cy: ellipse.cy,
    rx: ellipse.rx,
    ry: ellipse.ry,
    style: {
      fill: 'none',
      stroke: ellipse.lineColor,
      strokeWidth: ellipse.lineWidth
    },
    className: classnames(_defineProperty({}, styles$3.ellipseHover, !drawing))
  });
}
function createEllipse(point, workingDrawTool) {
  return {
    id: id(),
    lineColor: workingDrawTool.drawColor,
    lineWidth: workingDrawTool.drawWidth,
    type: 'circle',
    cx: point.x,
    cy: point.y,
    rx: 1,
    ry: 1
  };
}
function drawEllipse(ellipse, point) {
  var rx = point.x - ellipse.cx;
  var ry = point.y - ellipse.cy;

  if (rx < 1 || ry < 1) {
    return null;
  }

  return _objectSpread2(_objectSpread2({}, ellipse), {}, {
    rx: rx,
    ry: ry
  });
}

var css_248z$4 = ".index_textArea__ytiB9 {\n  border: none;\n  outline: none;\n  padding: 0;\n  border-radius: 0;\n  position: absolute;\n}\n.index_textAreaBorder__1VtOj {\n  border: 1px solid #d3d3d3;\n  outline: 1px solid #d3d3d3;\n}\n.index_textHover__3bKjG:hover {\n  color: #007fe1 !important;\n}\n";
var styles$4 = {"textArea":"index_textArea__ytiB9","textAreaBorder":"index_textAreaBorder__1VtOj","textHover":"index_textHover__3bKjG"};
styleInject(css_248z$4);

function DivText(_ref) {
  var _classnames;

  var text = _ref.text,
      onChange = _ref.onChange,
      drawing = _ref.drawing,
      onClick = _ref.onClick,
      onDoubleClick = _ref.onDoubleClick;
  var divRef = useRef(null);
  var isEditing = useMemo(function () {
    return text.editing;
  }, [text]);

  var _useClickHooks = useClickHooks(),
      createClickHandler = _useClickHooks.createClickHandler,
      createDoubleClickHandler = _useClickHooks.createDoubleClickHandler;

  var onClickHandler = useMemo(function () {
    return createClickHandler(onClick);
  }, [createClickHandler, onClick]);
  var onDoubleClickHandler = useMemo(function () {
    return createDoubleClickHandler(onDoubleClick);
  }, [createDoubleClickHandler, onDoubleClick]);
  var onBlurHandler = useCallback(function () {
    var _divRef$current;

    onChange && onChange((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.innerText);
  }, [onChange, divRef]);
  useEffect(function () {
    var divElement = divRef.current;

    var listener = function listener(event) {
      var clickInside = divElement.contains(event.target);

      if (!clickInside && (divElement === null || divElement === void 0 ? void 0 : divElement.getAttribute('contenteditable')) === 'true') {
        onBlurHandler();
      }
    };

    document.addEventListener('click', listener, false);
    return function () {
      document.removeEventListener('click', listener, false);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (isEditing) {
      var _divRef$current2;

      (_divRef$current2 = divRef.current) === null || _divRef$current2 === void 0 ? void 0 : _divRef$current2.focus();
    }
  }, [isEditing]);
  return /*#__PURE__*/React.createElement("div", {
    ref: divRef,
    id: text.id,
    style: {
      left: text.x,
      top: text.y - text.lineWidth,
      fontSize: text.lineWidth,
      color: text.lineColor
    },
    className: classnames((_classnames = {}, _defineProperty(_classnames, styles$4.textHover, !drawing && !isEditing), _defineProperty(_classnames, styles$4.textAreaBorder, isEditing), _classnames), styles$4.textArea),
    contentEditable: isEditing,
    onClick: !isEditing ? onClickHandler : undefined,
    onDoubleClick: !isEditing ? onDoubleClickHandler : undefined,
    onBlur: onBlurHandler,
    dangerouslySetInnerHTML: {
      __html: text.words.replace(/\n/g, '<br/>')
    }
  });
}
function createText(point, workingDrawTool) {
  return {
    id: id(),
    lineColor: workingDrawTool.drawColor,
    lineWidth: workingDrawTool.drawWidth,
    type: 'text',
    x: point.x,
    y: point.y,
    words: 'Type words here',
    editing: true
  };
}

function Divider(_ref) {
  var length = _ref.length;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 5,
      marginRight: 5,
      borderLeft: '1px solid #dcdcdc',
      height: length,
      width: 1,
      display: 'inline-block'
    }
  });
}

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCancelCircled(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.1 1000"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M641 626q0-14-10-25L530 500l101-101q10-11 10-25 0-15-10-26l-51-50q-10-11-25-11t-25 11L429 399 328 298q-11-11-25-11-16 0-26 11l-50 50q-11 11-11 26 0 14 11 25l101 101-101 101q-11 11-11 25 0 15 11 26l50 50q10 11 26 11 14 0 25-11l101-101 101 101q10 11 25 11t25-11l51-50q10-11 10-26zm216-126q0 117-57 215T644 871t-215 58-216-58T58 715 0 500t58-215 155-156 216-58 215 58 156 156 57 215z"
  })));
}

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgCcw(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.1 1000"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    d: "M857 500q0 87-34 166t-91 137-137 92-166 34q-96 0-183-41T99 774q-4-6-4-13t5-11l76-77q6-5 14-5 9 1 13 7 41 53 100 82t126 29q58 0 110-23t92-61 61-91 22-111-22-111-61-91-92-61-110-23q-55 0-105 20t-90 57l77 77q17 16 8 38-10 23-33 23H36q-15 0-25-11T0 393V143q0-24 22-33 22-10 39 8l72 72q60-57 137-88t159-31q87 0 166 34t137 92 91 137 34 166z"
  })));
}

var _path$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgCheckEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 785.7 1000"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    d: "M625 143H161q-37 0-63 26t-27 63v464q0 37 27 63t63 27h464q37 0 63-27t26-63V232q0-37-26-63t-63-26zm161 89v464q0 67-47 114t-114 47H161q-67 0-114-47T0 696V232q0-66 47-113t114-48h464q66 0 114 48t47 113z"
  })));
}

var _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgCircleEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.1 1000"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M429 196q-83 0-153 41T166 348t-41 152 41 152 110 111 153 41 152-41 110-111 41-152-41-152-110-111-152-41zm428 304q0 117-57 215T644 871t-215 58-216-58T58 715 0 500t58-215 155-156 216-58 215 58 156 156 57 215z"
  })));
}

var _path$4;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgCircleThin(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.1 1000"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M429 143q-73 0-139 28t-114 76-76 114-29 139 29 139 76 113 114 77 139 28 138-28 114-77 76-113 29-139-29-139-76-114-114-76-138-28zm428 357q0 117-57 215T644 871t-215 58-216-58T58 715 0 500t58-215 155-156 216-58 215 58 156 156 57 215z"
  })));
}

var _path$5;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgColumns(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 928.6 1000"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    d: "M89 857h340V214H71v625q0 7 6 13t12 5zm768-18V214H500v643h339q8 0 13-5t5-13zm72-678v678q0 37-27 63t-63 27H89q-36 0-63-27T0 839V161q0-37 26-63t63-27h750q37 0 63 27t27 63z"
  })));
}

var _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgCw(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.1 1000"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    d: "M857 143v250q0 14-10 25t-26 11H571q-23 0-32-23-10-22 7-38l77-77q-82-77-194-77-58 0-111 23t-91 61-61 91-23 111 23 111 61 91 91 61 111 23q66 0 125-29t100-82q4-6 13-7 8 0 14 5l76 77q5 4 6 11t-5 13q-60 74-147 114t-182 41q-87 0-167-34t-136-92-92-137T0 500t34-166 92-137 136-92 167-34q82 0 158 31t137 88l72-72q17-18 39-8 22 9 22 33z"
  })));
}

var _path$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 928.6 1000"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M714 750q0-15-10-25t-25-11-25 11-11 25 11 25 25 11 25-11 10-25zm143 0q0-15-10-25t-26-11-25 11-10 25 10 25 25 11 26-11 10-25zm72-125v179q0 22-16 37t-38 16H54q-23 0-38-16T0 804V625q0-22 16-38t38-16h259l75 76q33 32 76 32t76-32l76-76h259q22 0 38 16t16 38zM747 307q10 23-8 39L489 596q-10 11-25 11t-25-11L189 346q-17-16-8-39 10-21 33-21h143V36q0-15 11-25t25-11h143q14 0 25 11t10 25v250h143q24 0 33 21z"
  })));
}

var _path$8;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgEmoUnhappy(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 999 1000"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    d: "M261 50c-60 0-109 65-109 144 0 80 49 145 109 145s110-65 110-145c0-79-49-144-110-144zm477 0c-61 0-110 65-110 144 0 80 49 145 110 145 60 0 110-65 110-145 0-79-50-144-110-144zM494 649c-165 0-331 62-461 184l-3 3c-6 5-11 10-14 14-21 21-21 55-1 76 21 21 54 21 75 1l12-12 3-3c111-105 254-157 396-155 143 1 285 56 396 165l12 12c20 21 54 21 74 1 21-21 21-55 1-77-5-5-9-10-14-14-131-129-299-194-468-195h-8z"
  })));
}

var _path$9;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgEraser(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1071.4 1000"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    d: "M500 786l188-215H259L71 786h429zm565-601q9 19 6 40t-17 36L554 833q-22 24-54 24H71q-21 0-38-11T6 815q-8-19-5-40t17-36l500-572q21-24 53-24h429q21 0 39 11t26 31z"
  })));
}

var _path$a;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgFileWord(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.1 1000"
  }, props), _path$a || (_path$a = /*#__PURE__*/createElement("path", {
    d: "M819 212q16 16 27 42t11 50v642q0 23-15 38t-38 16H54q-23 0-38-16T0 946V54q0-23 16-38T54 0h500q22 0 49 11t42 27zM571 76v210h210q-5-17-12-23L594 88q-6-7-23-12zm215 853V357H554q-23 0-38-16t-16-37V71H71v858h715zM130 429v59h39l92 369h88l72-271q4-11 5-25 2-9 2-14h2l1 14q1 1 2 11t3 14l72 271h89l91-369h39v-59H560v59h50l-55 245q-3 11-4 25l-1 12h-3v-4q0-2-1-4t0-4q-1-2-2-11t-3-14l-81-304h-63l-81 304q-1 5-2 13t-2 12l-2 12h-2l-2-12q-1-14-3-25l-56-245h50v-59H130z"
  })));
}

var _path$b;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgLevelDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744 1000"
  }, props), _path$b || (_path$b = /*#__PURE__*/createElement("path", {
    d: "M100 650q-42 0-71-30T0 550V200h140v310h364V360l240 220-240 220V650H100z"
  })));
}

var _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function SvgMove(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000"
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement("path", {
    d: "M1000 500q0 14-11 25L847 668q-11 11-26 11t-25-11-10-25v-72H571v215h72q14 0 25 10t11 25-11 25L525 989q-10 11-25 11t-25-11L332 846q-11-10-11-25t11-25 25-10h72V571H214v72q0 14-10 25t-25 11-25-11L11 525Q0 514 0 500t11-25l143-143q10-11 25-11t25 11 10 25v72h215V214h-72q-14 0-25-10t-11-25 11-26L475 11q11-11 25-11t25 11l143 142q11 11 11 26t-11 25-25 10h-72v215h215v-72q0-14 10-25t25-11 26 11l142 143q11 10 11 25z"
  })));
}

var _path$d;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function SvgPencil(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.1 1000"
  }, props), _path$d || (_path$d = /*#__PURE__*/createElement("path", {
    d: "M203 857l50-51-131-131-51 51v60h72v71h60zm291-518q0-12-12-12-5 0-9 4L170 633q-4 4-4 10 0 12 13 12 5 0 9-4l303-302q3-4 3-10zm-30-107l232 232-464 465H0V696zm381 54q0 29-20 50l-93 93-232-233 93-92q20-21 50-21 29 0 51 21l131 131q20 22 20 51z"
  })));
}

var _path$e;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function SvgTrashEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 785.7 1000"
  }, props), _path$e || (_path$e = /*#__PURE__*/createElement("path", {
    d: "M286 411v321q0 8-5 13t-13 5h-36q-8 0-13-5t-5-13V411q0-8 5-13t13-5h36q8 0 13 5t5 13zm143 0v321q0 8-5 13t-13 5h-36q-8 0-13-5t-5-13V411q0-8 5-13t13-5h36q8 0 13 5t5 13zm142 0v321q0 8-5 13t-12 5h-36q-8 0-13-5t-5-13V411q0-8 5-13t13-5h36q7 0 12 5t5 13zm72 404V286H143v529q0 12 4 22t8 15 6 5h464q2 0 6-5t8-15 4-22zM268 214h250l-27-65q-4-5-9-6H305q-6 1-10 6zm518 18v36q0 8-5 13t-13 5h-54v529q0 46-26 80t-63 34H161q-37 0-63-33t-27-79V286H18q-8 0-13-5t-5-13v-36q0-8 5-13t13-5h172l39-93q9-21 31-35t44-15h178q23 0 44 15t30 35l39 93h173q8 0 13 5t5 13z"
  })));
}

function BaseIcon(_ref) {
  var type = _ref.type,
      style = _ref.style,
      className = _ref.className,
      onClick = _ref.onClick,
      dataType = _ref.dataType;
  var Svg = null;

  if (type === 'cancel-circled') {
    Svg = SvgCancelCircled;
  }

  if (type === 'ccw') {
    Svg = SvgCcw;
  }

  if (type === 'check-empty') {
    Svg = SvgCheckEmpty;
  }

  if (type === 'circle-empty') {
    Svg = SvgCircleEmpty;
  }

  if (type === 'circle-thin') {
    Svg = SvgCircleThin;
  }

  if (type === 'columns') {
    Svg = SvgColumns;
  }

  if (type === 'cw') {
    Svg = SvgCw;
  }

  if (type === 'download') {
    Svg = SvgDownload;
  }

  if (type === 'emo-unhappy') {
    Svg = SvgEmoUnhappy;
  }

  if (type === 'eraser') {
    Svg = SvgEraser;
  }

  if (type === 'file-word') {
    Svg = SvgFileWord;
  }

  if (type === 'level-down') {
    Svg = SvgLevelDown;
  }

  if (type === 'move') {
    Svg = SvgMove;
  }

  if (type === 'pencil') {
    Svg = SvgPencil;
  }

  if (type === 'trash-empty') {
    Svg = SvgTrashEmpty;
  }

  if (!Svg) {
    throw new Error('unknown icon type');
  }

  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    style: style,
    onClick: onClick,
    "data-type": dataType
  });
}

var css_248z$5 = ".index_iconBlock__2cgvX {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 38px;\n  height: 38px;\n  border: 1px solid #fff;\n  transition: border 0.3s ease;\n  position: relative;\n}\n.index_iconBlock__2cgvX:hover {\n  border: 1px solid #d7d7d7;\n}\n.index_icon__1Vg0z {\n  width: 16px;\n  height: 16px;\n}\n.index_disabled__3kW3W {\n  color: #b1b1b1;\n  fill: #b1b1b1;\n}\n.index_active__19rey {\n  background-color: #e6e6e6;\n}\n.index_tooltip__1rcfq {\n  position: absolute;\n  transform: translate(0, 30px);\n  height: 20px;\n  white-space: nowrap;\n  padding: 2px 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 3px;\n  background-color: #000;\n  opacity: 0.8;\n  color: #fff;\n  z-index: 10;\n}\n.index_hide__3u4aY {\n  display: none;\n}\n";
var styles$5 = {"iconBlock":"index_iconBlock__2cgvX","icon":"index_icon__1Vg0z","disabled":"index_disabled__3kW3W","active":"index_active__19rey","tooltip":"index_tooltip__1rcfq","hide":"index_hide__3u4aY"};
styleInject(css_248z$5);

function ToolIcon(_ref) {
  var _classnames;

  var type = _ref.type,
      disabled = _ref.disabled,
      active = _ref.active,
      tooltip = _ref.tooltip,
      iconClass = _ref.iconClass,
      _onClick = _ref.onClick,
      children = _ref.children,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      tipVisible = _useState2[0],
      setTipVisible = _useState2[1];

  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setTipVisible(true);
      _onMouseEnter && _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      setTipVisible(false);
      _onMouseLeave && _onMouseLeave();
    },
    className: classnames(styles$5.iconBlock, (_classnames = {}, _defineProperty(_classnames, styles$5.disabled, disabled), _defineProperty(_classnames, styles$5.active, !disabled && active), _classnames)),
    onClick: function onClick(e) {
      if (!disabled) {
        _onClick && _onClick(e);
      }
    }
  }, /*#__PURE__*/React.createElement(BaseIcon, {
    type: iconClass,
    className: classnames(styles$5.icon)
  }), !children && /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$5.tooltip, _defineProperty({}, styles$5.hide, !tipVisible))
  }, tooltip ? tooltip : capitalize(type)), children);
}

var css_248z$6 = ".index_paletteContainer__3HLFO {\n  width: 280px;\n  height: 30px;\n  box-shadow: 2px 2px 2px #c7c7c7;\n  border: 0.5px solid #eee;\n  position: absolute;\n  left: 0;\n  top: 40px;\n  padding: 2px 5px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  z-index: 10;\n  background-color: #fff;\n}\n.index_inputField__29haB {\n  border: 1px solid #dcdcdc;\n  height: 20px;\n  width: 30px;\n  padding: 0 3px;\n}\n.index_inputField__29haB:focus {\n  border: 1px solid #bababa;\n  outline: none;\n}\n.index_colorPickContainer__dA0_S {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #dadada;\n  padding: 2px;\n  margin-right: 3px;\n}\n.index_colorPick__189Wy {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  padding: 1px;\n}\n";
var styles$6 = {"paletteContainer":"index_paletteContainer__3HLFO","inputField":"index_inputField__29haB","colorPickContainer":"index_colorPickContainer__dA0_S","colorPick":"index_colorPick__189Wy"};
styleInject(css_248z$6);

var COLORS = [Color.BLACK, Color.BLUE, Color.BLUENESS, Color.GREEN, Color.PURPLE, Color.RED, Color.YELLOW, Color.WHITE];
function Palette(_ref) {
  var color = _ref.color,
      width = _ref.width,
      onColorChange = _ref.onColorChange,
      onWidthChange = _ref.onWidthChange,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.paletteContainer,
    style: style
  }, /*#__PURE__*/React.createElement("input", {
    className: styles$6.inputField,
    value: width,
    type: "number",
    "data-type": "IGNORE_BY_MOUSEUP",
    onChange: function onChange(e) {
      e.stopPropagation();
      e.preventDefault();
      var val = e.target.value;

      if (!isNumeric(val)) {
        return;
      }

      var width = Number(val);

      if (width > 30 || width <= 0) {
        return;
      }

      return onWidthChange(width);
    }
  }), /*#__PURE__*/React.createElement(Divider, {
    length: 30
  }), COLORS.map(function (c) {
    return /*#__PURE__*/React.createElement("div", {
      key: c,
      className: styles$6.colorPickContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6.colorPick,
      style: {
        backgroundColor: c,
        color: c === Color.WHITE ? '#000' : '#fff',
        cursor: color === c ? 'auto' : 'pointer'
      },
      "data-type": "IGNORE_BY_MOUSEUP",
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        onColorChange(c);
      }
    }, color === c ? /*#__PURE__*/React.createElement(React.Fragment, null, "\u221A") : null));
  }));
}

var css_248z$7 = ".index_closeBtn__2tNFi {\n  cursor: pointer;\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  color: red;\n  fill: red;\n  width: 15px;\n  height: 15px;\n}\n";
var styles$7 = {"closeBtn":"index_closeBtn__2tNFi"};
styleInject(css_248z$7);

function toLine(line, clickPosition, originalClickPosition) {
  var points = line.points;
  var offset = {
    x: clickPosition.x - originalClickPosition.x,
    y: clickPosition.y - originalClickPosition.y
  };
  return _objectSpread2(_objectSpread2({}, line), {}, {
    points: points.map(function (p) {
      return {
        x: p.x + offset.x,
        y: p.y + offset.y
      };
    })
  });
}

function toRect(rect, clickPosition, originalClickPosition) {
  var offset = {
    x: clickPosition.x - originalClickPosition.x,
    y: clickPosition.y - originalClickPosition.y
  };
  return _objectSpread2(_objectSpread2({}, rect), {}, {
    x: rect.x + offset.x,
    y: rect.y + offset.y
  });
}

function toEllipse(ellipse, clickPosition, originalClickPosition) {
  var offset = {
    x: clickPosition.x - originalClickPosition.x,
    y: clickPosition.y - originalClickPosition.y
  };
  return _objectSpread2(_objectSpread2({}, ellipse), {}, {
    cx: ellipse.cx + offset.x,
    cy: ellipse.cy + offset.y
  });
}

function toText(text, clickPosition, originalClickPosition) {
  var offset = {
    x: clickPosition.x - originalClickPosition.x,
    y: clickPosition.y - originalClickPosition.y
  };
  return _objectSpread2(_objectSpread2({}, text), {}, {
    x: text.x + offset.x,
    y: text.y + offset.y
  });
}

function SelectBox(_ref) {
  var shape = _ref.shape,
      containerBoundingClientRect = _ref.containerBoundingClientRect,
      onMoving = _ref.onMoving,
      onClose = _ref.onClose,
      onShapeChange = _ref.onShapeChange;

  var _useState = useState({
    x: 0,
    y: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      originalClickPosition = _useState2[0],
      setOriginalClickPosition = _useState2[1];

  var _useState3 = useState({
    x: 0,
    y: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      originalClickOffsetToRect = _useState4[0],
      setOriginalClickOffsetToRect = _useState4[1];

  var _useState5 = useState(shape),
      _useState6 = _slicedToArray(_useState5, 2),
      originalShape = _useState6[0],
      setOriginalShape = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      resetOriginalShapeTrigger = _useState8[0],
      setResetOriginalShapeTrigger = _useState8[1];

  var shapeId = shape.id;
  var boxRect = useMemo(function () {
    var _document$querySelect;

    if (!shapeId || !containerBoundingClientRect) {
      return {
        top: -1,
        left: -1,
        width: 0,
        height: 0
      };
    }

    var rect = (_document$querySelect = document.querySelector("#".concat(shapeId))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect();

    if (!rect) {
      return {
        top: -1,
        left: -1,
        width: 0,
        height: 0
      };
    }

    return {
      top: rect.top - containerBoundingClientRect.top - 8,
      left: rect.left - containerBoundingClientRect.left - 8,
      width: rect.width + 16,
      height: rect.height + 16
    };
  }, [shapeId, containerBoundingClientRect]);
  useEffect(function () {
    if (!shapeId) {
      return;
    }

    setOriginalShape(shape); // Note: only watch shapeId here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shapeId, setOriginalShape, resetOriginalShapeTrigger]);

  if (!containerBoundingClientRect) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    "data-type": "IGNORE_BY_MOUSEUP",
    draggable: true,
    style: {
      position: 'absolute',
      top: boxRect.top,
      left: boxRect.left,
      width: boxRect.width,
      height: boxRect.height,
      border: '1px solid #d3d3d3'
    },
    onDragStart: function onDragStart(e) {
      var startPoint = {
        x: e.clientX - containerBoundingClientRect.left,
        y: e.clientY - containerBoundingClientRect.top
      };
      var clickOffsetToBox = {
        x: startPoint.x - boxRect.left,
        y: startPoint.y - boxRect.top
      };
      setOriginalClickOffsetToRect(clickOffsetToBox);
      setOriginalClickPosition(startPoint);
    },
    onDrag: function onDrag(e) {
      if (!onMoving) {
        return;
      }

      if (e.clientX === 0 && e.clientY === 0) {
        return;
      }

      var clickPosition = {
        x: e.clientX - containerBoundingClientRect.left,
        y: e.clientY - containerBoundingClientRect.top
      };

      if (clickPosition.x - originalClickOffsetToRect.x < 1 || clickPosition.x - originalClickOffsetToRect.x + boxRect.width > containerBoundingClientRect.width || clickPosition.y - originalClickOffsetToRect.y < 1 || clickPosition.y - originalClickOffsetToRect.y + boxRect.height > containerBoundingClientRect.height) {
        return;
      }

      var newShape = null;

      if (shape.type === 'line') {
        newShape = toLine(originalShape, clickPosition, originalClickPosition);
      } else if (shape.type === 'rect') {
        newShape = toRect(originalShape, clickPosition, originalClickPosition);
      } else if (shape.type === 'circle') {
        newShape = toEllipse(originalShape, clickPosition, originalClickPosition);
      } else if (shape.type === 'text') {
        newShape = toText(originalShape, clickPosition, originalClickPosition);
      }

      if (newShape) {
        onMoving(newShape);
      }
    },
    onDragEnd: function onDragEnd(e) {
      setResetOriginalShapeTrigger(new Date().getTime());
    }
  }, /*#__PURE__*/React.createElement(BaseIcon, {
    type: "cancel-circled",
    className: classnames(styles$7.closeBtn),
    dataType: "IGNORE_BY_MOUSEUP",
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      onClose && onClose(shapeId);
    }
  }), /*#__PURE__*/React.createElement(Palette, {
    style: {
      top: boxRect.height,
      left: -1
    },
    color: shape.lineColor,
    width: shape.lineWidth,
    onColorChange: function onColorChange(color) {
      onShapeChange(shapeId, _objectSpread2(_objectSpread2({}, shape), {}, {
        lineColor: color
      }));
      setResetOriginalShapeTrigger(new Date().getTime());
    },
    onWidthChange: function onWidthChange(width) {
      onShapeChange(shapeId, _objectSpread2(_objectSpread2({}, shape), {}, {
        lineWidth: width
      }));
      setResetOriginalShapeTrigger(new Date().getTime());
    }
  }));
}

var css_248z$8 = ".index_drawingAreaContainer__1i6g9 {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.index_drawing__wUZlF {\n  width: 100%;\n  height: 100%;\n}\n";
var styles$8 = {"drawingAreaContainer":"index_drawingAreaContainer__1i6g9","drawing":"index_drawing__wUZlF"};
styleInject(css_248z$8);

function createShape(point, workingDrawTool) {
  if (workingDrawTool.type === 'line') {
    return createLine(point, workingDrawTool);
  }

  if (workingDrawTool.type === 'arrow-line') {
    return createArrowLine(point, workingDrawTool);
  }

  if (workingDrawTool.type === 'rect') {
    return createRect(point, workingDrawTool);
  }

  if (workingDrawTool.type === 'circle') {
    return createEllipse(point, workingDrawTool);
  }

  if (workingDrawTool.type === 'text') {
    return createText(point, workingDrawTool);
  }

  return null;
}

function drawShape(point, workingDrawTool, shapes) {
  if (workingDrawTool.type === 'line') {
    var lastLine = shapes[shapes.length - 1];
    return drawLine(lastLine, point);
  }

  if (workingDrawTool.type === 'arrow-line') {
    var _lastLine = shapes[shapes.length - 1];
    return drawArrowLine(_lastLine, point);
  }

  if (workingDrawTool.type === 'rect') {
    var lastRect = shapes[shapes.length - 1];
    return drawRect(lastRect, point);
  }

  if (workingDrawTool.type === 'circle') {
    var lastEllipse = shapes[shapes.length - 1];
    return drawEllipse(lastEllipse, point);
  }

  if (workingDrawTool.type === 'text') {
    return null;
  }

  return null;
}

function cleanJustClickedShape(shapes, removeShape) {
  if (!shapes.length) {
    return false;
  }

  var lastShape = shapes[shapes.length - 1];

  if (lastShape.type === 'line' && lastShape.points.length === 1) {
    removeShape(lastShape.id);
    return true;
  }

  if (lastShape.type === 'arrow-line' && lastShape.points.length === 1) {
    removeShape(lastShape.id);
    return true;
  }

  if (lastShape.type === 'rect' && (lastShape.width <= 1 || lastShape.height <= 1)) {
    removeShape(lastShape.id);
    return true;
  }

  if (lastShape.type === 'circle' && (lastShape.rx <= 1 || lastShape.ry <= 1)) {
    removeShape(lastShape.id);
    return true;
  }

  return false;
}

function SvgDrawingPad(_ref) {
  var id = _ref.id;
  var drawAreaRef = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      cleanUnfinishedShapeThreshold = _useState2[0],
      setCleanUnfinishedShapeThreshold = _useState2[1];

  var _useContext = useContext(PaintingStateContext),
      drawing = _useContext.drawing,
      setDrawing = _useContext.setDrawing,
      drawMode = _useContext.drawMode,
      setDrawMode = _useContext.setDrawMode,
      shapes = _useContext.shapes,
      addShape = _useContext.addShape,
      updateShape = _useContext.updateShape,
      workingDrawTool = _useContext.workingDrawTool,
      setWorkingDrawTool = _useContext.setWorkingDrawTool,
      removeShape = _useContext.removeShape,
      selectedShape = _useContext.selectedShape,
      setSelectedShape = _useContext.setSelectedShape,
      cleanRedoShapes = _useContext.cleanRedoShapes;

  var lines = useMemo(function () {
    return shapes.filter(function (s) {
      return s.type === 'line';
    });
  }, [shapes]);
  var arrowLines = useMemo(function () {
    return shapes.filter(function (s) {
      return s.type === 'arrow-line';
    });
  }, [shapes]);
  var rects = useMemo(function () {
    return shapes.filter(function (s) {
      return s.type === 'rect';
    });
  }, [shapes]);
  var ellipses = useMemo(function () {
    return shapes.filter(function (s) {
      return s.type === 'circle';
    });
  }, [shapes]);
  var divTexts = useMemo(function () {
    return shapes.filter(function (s) {
      return s.type === 'text';
    });
  }, [shapes]);
  var relativeCoordinatesForEvent = useCallback(function (e) {
    if (!drawAreaRef.current) {
      return null;
    }

    var boundingRect = drawAreaRef.current.getBoundingClientRect();
    return {
      x: e.clientX - boundingRect.left,
      y: e.clientY - boundingRect.top
    };
  }, [drawAreaRef]);
  var handleMouseDown = useCallback(function (e) {
    // not left click, ignore
    if (e.button !== 0 || e.buttons !== 1) {
      return;
    } // not a valid click point


    var point = relativeCoordinatesForEvent(e);

    if (!point) {
      return;
    } // draw mode


    if (drawMode === IDrawMode.DRAW) {
      setDrawing(true);
      var newShape = createShape(point, workingDrawTool);
      addShape(newShape);
    } // select mode


    if (drawMode === IDrawMode.SELECT) {
      return;
    }
  }, [setDrawing, addShape, drawMode, workingDrawTool, relativeCoordinatesForEvent]);
  var handleMouseMove = useCallback(function (e) {
    // not a valid move point
    var point = relativeCoordinatesForEvent(e);

    if (!point) {
      return;
    } // draw mode


    if (drawMode === IDrawMode.DRAW) {
      // ignore if not started
      if (!drawing) {
        return;
      }

      var lastShape = shapes[shapes.length - 1];
      updateShape(lastShape.id, drawShape(point, workingDrawTool, shapes));
    }
  }, [drawing, drawMode, updateShape, shapes, workingDrawTool, relativeCoordinatesForEvent]);
  var cleanUnfinishedShape = useCallback(function () {
    // remove just clicked shape
    var removed = cleanJustClickedShape(shapes, removeShape);

    if (!removed) {
      cleanRedoShapes();
    }
  }, [cleanRedoShapes, shapes, removeShape]);
  var handleMouseUp = useCallback(function (e) {
    // ignore if click from toolbar, selectbox
    if (e.target.dataset && e.target.dataset.type === 'IGNORE_BY_MOUSEUP') {
      return;
    }

    if (drawMode === IDrawMode.DRAW) {
      // end drawing
      setDrawing(false);
      setCleanUnfinishedShapeThreshold(new Date().getTime());
    }

    if (drawMode !== IDrawMode.SELECT) {
      setDrawMode(IDrawMode.SELECT);
      setWorkingDrawTool(null);
    }

    if (drawMode === IDrawMode.SELECT) {
      if (selectedShape) {
        setSelectedShape(null);
      }
    }
  }, [setDrawing, drawMode, setDrawMode, setWorkingDrawTool, selectedShape, setSelectedShape, setCleanUnfinishedShapeThreshold]);
  var selectShape = useCallback(function (e, shape) {
    e.stopPropagation();
    e.preventDefault();

    if (selectedShape && selectedShape.id === shape.id) {
      return;
    }

    setSelectedShape(shape);
  }, [selectedShape, setSelectedShape]);
  var moving = useCallback(function (shape) {
    if (!selectedShape) {
      return;
    }

    updateShape(selectedShape.id, shape);
    setSelectedShape(shape);
  }, [selectedShape, updateShape, setSelectedShape]);
  useEffect(function () {
    document.addEventListener('mouseup', handleMouseUp, false);
    return function () {
      document.removeEventListener('mouseup', handleMouseUp, false);
    };
  }, [handleMouseUp, shapes]);
  useEffect(function () {
    cleanUnfinishedShape(); // Note: only watch cleanUnfinishedShapeThreshold here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cleanUnfinishedShapeThreshold]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: styles$8.drawingAreaContainer,
    ref: drawAreaRef,
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onDragOver: function onDragOver(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement("svg", {
    className: styles$8.drawing
  }, /*#__PURE__*/React.createElement("defs", null, arrowLines.map(function (line, index) {
    return /*#__PURE__*/React.createElement(ArrowLineMarker, {
      key: line.id,
      arrowLine: line
    });
  })), lines.map(function (line, index) {
    return /*#__PURE__*/React.createElement(Line, {
      drawing: drawing,
      key: line.id,
      line: line,
      onClick: function onClick(e) {
        selectShape(e, line);
      }
    });
  }), arrowLines.map(function (line, index) {
    return /*#__PURE__*/React.createElement(ArrowLine, {
      drawing: drawing,
      key: line.id,
      arrowLine: line,
      onClick: function onClick(e) {
        selectShape(e, line);
      }
    });
  }), rects.map(function (rect, index) {
    return /*#__PURE__*/React.createElement(Rect, {
      drawing: drawing,
      key: rect.id,
      rect: rect,
      onClick: function onClick(e) {
        selectShape(e, rect);
      }
    });
  }), ellipses.map(function (ellipse, index) {
    return /*#__PURE__*/React.createElement(Ellipse, {
      drawing: drawing,
      key: ellipse.id,
      ellipse: ellipse,
      onClick: function onClick(e) {
        selectShape(e, ellipse);
      }
    });
  })), divTexts.map(function (text, index) {
    return /*#__PURE__*/React.createElement(DivText, {
      key: text.id,
      drawing: drawing,
      text: text,
      onClick: function onClick(e) {
        selectShape(e, text);
      },
      onDoubleClick: function onDoubleClick(e) {
        updateShape(text.id, _objectSpread2(_objectSpread2({}, text), {}, {
          editing: true
        }));
      },
      onChange: function onChange(words) {
        updateShape(text.id, _objectSpread2(_objectSpread2({}, text), {}, {
          words: words,
          editing: false
        }));
      }
    });
  }), selectedShape && /*#__PURE__*/React.createElement(SelectBox, {
    shape: selectedShape,
    containerBoundingClientRect: drawAreaRef.current && drawAreaRef.current.getBoundingClientRect(),
    onMoving: moving,
    onClose: removeShape,
    onShapeChange: function onShapeChange(id, shape) {
      updateShape(id, shape);
    }
  }));
}

function BaseDrawTool(_ref) {
  var type = _ref.type,
      iconClass = _ref.iconClass,
      tooltip = _ref.tooltip,
      defaultColor = _ref.defaultColor,
      defaultWidth = _ref.defaultWidth;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      canPaletteVisible = _useState2[0],
      setPaletteVisible = _useState2[1];

  var _useContext = useContext(PaintingStateContext),
      workingDrawTool = _useContext.workingDrawTool,
      setWorkingDrawTool = _useContext.setWorkingDrawTool,
      setDrawMode = _useContext.setDrawMode;

  var _useState3 = useState(workingDrawTool && workingDrawTool.type === type ? workingDrawTool.drawColor : defaultColor),
      _useState4 = _slicedToArray(_useState3, 2),
      drawColor = _useState4[0],
      setDrawColor = _useState4[1];

  var _useState5 = useState(workingDrawTool && workingDrawTool.type === type ? workingDrawTool.drawWidth : defaultWidth),
      _useState6 = _slicedToArray(_useState5, 2),
      drawWidth = _useState6[0],
      setDrawWidth = _useState6[1];

  var isActive = useMemo(function () {
    return workingDrawTool && workingDrawTool.type === type;
  }, [workingDrawTool, type]);
  return /*#__PURE__*/React.createElement(ToolIcon, {
    type: type,
    active: isActive,
    iconClass: iconClass,
    tooltip: tooltip,
    onMouseEnter: function onMouseEnter() {
      return setPaletteVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setPaletteVisible(false);
    },
    onClick: function onClick(e) {
      if (isActive) {
        return;
      }

      setDrawMode(IDrawMode.DRAW);
      setWorkingDrawTool({
        type: type,
        drawColor: drawColor,
        drawWidth: drawWidth
      });
    }
  }, canPaletteVisible && isActive ? /*#__PURE__*/React.createElement(Palette, {
    width: drawWidth,
    color: drawColor,
    onWidthChange: function onWidthChange(e) {
      setDrawWidth(e);
      setWorkingDrawTool({
        type: type,
        drawColor: drawColor,
        drawWidth: e
      });
    },
    onColorChange: function onColorChange(e) {
      setDrawColor(e);
      setWorkingDrawTool({
        type: type,
        drawColor: e,
        drawWidth: drawWidth
      });
    }
  }) : null);
}

function Circle() {
  return /*#__PURE__*/React.createElement(BaseDrawTool, {
    type: "circle",
    iconClass: "circle-empty",
    tooltip: "Circle",
    defaultColor: Color.BLACK,
    defaultWidth: 4
  });
}

function Clean() {
  var _useContext = useContext(PaintingStateContext),
      shapes = _useContext.shapes,
      cleanBoard = _useContext.cleanBoard;

  return /*#__PURE__*/React.createElement(ToolIcon, {
    type: "delete",
    disabled: !shapes.length,
    iconClass: "trash-empty",
    tooltip: "Clean",
    onClick: cleanBoard
  });
}

function Pen() {
  return /*#__PURE__*/React.createElement(BaseDrawTool, {
    type: "line",
    iconClass: "pencil",
    tooltip: "Pen",
    defaultColor: Color.BLACK,
    defaultWidth: 4
  });
}

function Rect$1() {
  return /*#__PURE__*/React.createElement(BaseDrawTool, {
    type: "rect",
    iconClass: "columns",
    tooltip: "Rectangle",
    defaultColor: Color.BLACK,
    defaultWidth: 4
  });
}

function Redo() {
  var _useContext = useContext(PaintingStateContext),
      redoShapes = _useContext.redoShapes,
      redo = _useContext.redo;

  return /*#__PURE__*/React.createElement(ToolIcon, {
    type: "redo",
    disabled: !redoShapes.length,
    iconClass: "cw",
    onClick: redo
  });
}

function Save(_ref) {
  var padId = _ref.padId;

  var _useContext = useContext(PaintingStateContext),
      shapes = _useContext.shapes;

  return /*#__PURE__*/React.createElement(ToolIcon, {
    type: "save",
    disabled: !shapes.length,
    iconClass: "download",
    tooltip: "Save",
    onClick: function onClick() {
      downloadAsPng(document.getElementById(padId), 'exported-painting.png');
    }
  });
}

function Select() {
  var _useContext = useContext(PaintingStateContext),
      setDrawMode = _useContext.setDrawMode,
      drawMode = _useContext.drawMode,
      setWorkingDrawTool = _useContext.setWorkingDrawTool;

  return /*#__PURE__*/React.createElement(ToolIcon, {
    type: "select",
    iconClass: "move",
    active: drawMode === IDrawMode.SELECT,
    onClick: function onClick(e) {
      setDrawMode(IDrawMode.SELECT);
      setWorkingDrawTool(null);
    }
  });
}

function Text() {
  return /*#__PURE__*/React.createElement(BaseDrawTool, {
    type: "text",
    iconClass: "file-word",
    tooltip: "Text",
    defaultColor: Color.BLACK,
    defaultWidth: 18
  });
}

function Undo() {
  var _useContext = useContext(PaintingStateContext),
      shapes = _useContext.shapes,
      undo = _useContext.undo;

  return /*#__PURE__*/React.createElement(ToolIcon, {
    type: "undo",
    disabled: !shapes.length,
    iconClass: "ccw",
    onClick: undo
  });
}

function ArrowLine$1() {
  return /*#__PURE__*/React.createElement(BaseDrawTool, {
    type: "arrow-line",
    iconClass: "level-down",
    tooltip: "Arrow Line",
    defaultColor: Color.BLACK,
    defaultWidth: 4
  });
}

var css_248z$9 = ".index_toolbarContainerAtTop__27hxy {\n  height: 40.5px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  flex-shrink: 0;\n  border-bottom: 0.5px solid #ededed;\n}\n";
var styles$9 = {"toolbarContainerAtTop":"index_toolbarContainerAtTop__27hxy"};
styleInject(css_248z$9);

function Toolbar(_ref) {
  var padId = _ref.padId;
  var ctx = useContext(PaintingStateContext);

  if (!ctx) {
    throw new Error('context load error');
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.toolbarContainerAtTop
  }, /*#__PURE__*/React.createElement(Undo, null), /*#__PURE__*/React.createElement(Redo, null), /*#__PURE__*/React.createElement(Divider, {
    length: 25
  }), /*#__PURE__*/React.createElement(Select, null), /*#__PURE__*/React.createElement(Pen, null), /*#__PURE__*/React.createElement(ArrowLine$1, null), /*#__PURE__*/React.createElement(Text, null), /*#__PURE__*/React.createElement(Rect$1, null), /*#__PURE__*/React.createElement(Circle, null), /*#__PURE__*/React.createElement(Divider, {
    length: 25
  }), /*#__PURE__*/React.createElement(Clean, null), /*#__PURE__*/React.createElement(Divider, {
    length: 25
  }), /*#__PURE__*/React.createElement(Save, {
    padId: padId
  }));
}

var css_248z$a = ".index_appContainer__1tnvB {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n}\n.index_canvasContainer__3vl5H {\n  display: flex;\n  flex-grow: 2;\n}\n";
var styles$a = {"appContainer":"index_appContainer__1tnvB","canvasContainer":"index_canvasContainer__3vl5H"};
styleInject(css_248z$a);

var ReactPainting = function ReactPainting(_ref) {
  var style = _ref.style,
      className = _ref.className;
  var padId = id();
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: classnames(styles$a.appContainer, className)
  }, /*#__PURE__*/React.createElement(PaintingStateProvider, null, /*#__PURE__*/React.createElement(Toolbar, {
    padId: padId
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$a.canvasContainer
  }, /*#__PURE__*/React.createElement(SvgDrawingPad, {
    id: padId
  }))));
};

export { ReactPainting as ReactDoPainting };
